<template>
    <div class="bg">
        <div class="info">
            <label>{{title}}</label>
            <input type="text" placeholder="姓名" v-model="name">
            <input type="text" placeholder="手机号" v-model="phone">
            <span @click="toLogin">登录</span>
        </div>
    </div>
</template>

<script>
    import {umedSignLogin} from "@/assets/js/api";

    export default {
        name: "SignLogin",
        data(){
            return{
                name:null,
                phone: null,
                title:"首届大连国药心肺预防与康复高峰论坛"
            }
        },
        methods:{
            toLogin(){
                if(this.name==null||this.name==""){
                    this.$toast("请填写姓名")
                    return
                }
                if(this.phone==null||this.phone==null){
                    this.$toast("请填写手机号")
                    return;
                }
                this.login(this.name,this.phone)
            },
            async login(name,phone){
                const res = await umedSignLogin({name,phone})
                console.log(res,"12")
                if(res.data.success){
                    this.$router.push({path:"sign_info",query:{id:res.data.data}})
                }else{
                    this.$toast(res.data.message)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: #fff url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        overflow: scroll;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }
    .bg .info{
        width: 100%;
        margin: 0 auto;
        font-size: 16px;
        margin: 0 auto;
        input{
            display: block;
            width: 70%;
            margin: 0 auto 10px;
            font-size: 16px;
            padding: 3px 0;
            border: 1px #2c9a58 solid;
            border-radius: 5px;
            text-indent: 10px;
            outline: none;
        }
        span{
            display: block;
            background: #2c9a58;
            color: #FFF;
            width: 70%;
            padding: 3px;
            margin: 0 auto;
            border-radius: 5px;
        }
        label{
            margin-bottom: 30px;
            display: block;
            font-size: 14px;
            font-weight: bold;
        }
    }
</style>
